
import { createSlice } from "@reduxjs/toolkit";
import { commonInitialState } from "./state";

export const commonSlice = createSlice({
  name: "common",
  initialState: commonInitialState,
  reducers: {
    toogleBackdrop: (state, action) => {
      state.isBackdropShown = action.payload;
    },
    setVideoUploadData: (state, action) => {
      state.videoUploadData = action.payload;
    },
    setIsVideoUploading: (state, action) => {
      state.isVideoUploading = action.payload;
    },
    updateFilters: (state, action) => {
      state.filters = action.payload;
    },
  },
});
export default commonSlice.reducer;
